module.exports = __webpack_public_path__ + "img/d8-min.7638af59.png";